import videoModal from './video-modal.js';

(function() {
  'use strict';

    const modal = new videoModal();
    modal.init();

})();